import React, { memo } from 'react';
import * as Styles from './EmptyState.styles';

const EmptyState = memo(({
  icon,
  locale = {},
  button,
  testId,
}) => (
  <Styles.Container data-testid={testId}>
    <Styles.Content>
      <Styles.IconWrapper>
        {icon}
      </Styles.IconWrapper>
      <Styles.Text>
        <Styles.Title>{locale.title}</Styles.Title>
        <Styles.Description>{locale.description}</Styles.Description>
      </Styles.Text>
    </Styles.Content>
    <Styles.ButtonWrapper>
      {button}
    </Styles.ButtonWrapper>
  </Styles.Container>
));

export default EmptyState;
